/**
 * Stock severity for the Bajo-mínimo list.
 *
 * - red:   nothing on the shelf — actively can't sell.
 * - amber: at or below half the configured min — needs reorder soon.
 * - gray:  above amber threshold but still under min — informational.
 *
 * `min` of 0 (no min configured) collapses to gray for any positive on-hand.
 */
export type Severity = 'red' | 'amber' | 'gray';

export function severity(onHand: number, min: number): Severity {
  if (onHand === 0) return 'red';
  if (onHand <= Math.max(1, Math.floor(min / 2))) return 'amber';
  return 'gray';
}
